import { createSlice } from '@reduxjs/toolkit';

export const warehouseSlice = createSlice({
    name: 'warehouse',
    initialState: {
        isDragAvailable: false,
    },
    reducers: {
        changeIsDragAvailable(state, action) {
            state.isDragAvailable = action.payload;
        },
    },
});

export const { changeIsDragAvailable } = warehouseSlice.actions;

export default warehouseSlice.reducer;
